"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var web_1 = __importDefault(require("@splitbee/web"));
var defaultConfig = {
    pageEvent: "PageVisit",
    disableCookie: false,
    scriptUrl: "https://cdn.splitbee.io/sb.js",
    apiUrl: "https://hive.splitbee.io",
};
function logrocket(pluginConfig) {
    return {
        name: "splitbee-analytics",
        config: __assign(__assign({}, defaultConfig), pluginConfig),
        initialize: function (plugin) {
            var _a = plugin.config, pageEvent = _a.pageEvent, config = __rest(_a, ["pageEvent"]);
            web_1.default.init(config);
        },
        loaded: function () {
            return true;
        },
        identify: function (props) {
            var payload = props.payload;
            web_1.default.user.set(__assign({ id: payload.userId }, payload.traits));
        },
        page: function (opts) {
            var payload = opts.payload, config = opts.config;
            var properties = payload.properties;
            web_1.default.track(config.pageEvent, properties);
        },
        track: function (_a) {
            var payload = _a.payload;
            var properties = payload.properties, event = payload.event;
            web_1.default.track(event, properties);
        },
    };
}
exports.default = logrocket;
//# sourceMappingURL=splitbee.js.map